const __WEBPACK_NAMESPACE_OBJECT__ = globalThis["crateImports"]["@xing-com/crate-layout-scroll-memo-module"];